<template>
  <b-button :id="id" @click="click" :variant="getVariant" :class="{ 'shadow-btn': shadow, 'shadow-btn-pseudo': pseudoShadow, 'fit-content': fitContent, 'btn-negative': negative, 'font-weight-bold': bold, 'darken-on-hover': darkenOnHover, 'no-hover': noHoverStyles }" :size="size" :style="getOverridenStyles" :disabled="disabled">
		<base-icon v-if="icon" :src="icon" :color="iconColor || (lastInternalTextColor || internalTextColor)" class="mr-2"/>
		<slot v-if="!loading"></slot>
		<b-spinner v-else variant="light" label="Spinning" small></b-spinner>
  </b-button>
</template>

<script>
import { BButton, BSpinner } from 'bootstrap-vue'
import { BLUE_COLOUR, WHITE_COLOUR } from '@/constants/colours'

export default {
  components: {
    BButton,
		BSpinner
  },
	data () {
		return {
			internalTextColor: null,
			lastInternalTextColor: null
		}
	},
  props: {
    variant: {
      type: String
    },
    blue: Boolean,
    white: Boolean,
    red: Boolean,
    green: Boolean,
    gray: Boolean,
    outline: Boolean,
		negative: Boolean,
    shadow: Boolean,
    pseudoShadow: Boolean,
    transparent: Boolean,
    size: String,
    href: String,
    textColor: String,
    backgroundColor: String,
    borderColor: String,
    fitContent: Boolean,
		bold: Boolean,
    disabled: {
      type: Boolean,
      default: false
    },
		loading: {
			type: Boolean,
			default: false
		},
		icon: String,
		iconColor: String,
		noHoverStyles: Boolean
  },
  computed: {
		id () {
			return `base-button-${this._uid}`
		},
    getVariant () {
      return (this.outline ? 'outline-' : '') + (this.variant ? this.variant : this.getVariantFromProps())
    },
    getOverridenStyles () {
      let styles = {}

      if (this.backgroundColor) {
        styles['background-color'] = `${this.backgroundColor}`
      }
      if (this.borderColor) {
        styles.border = `1px solid ${this.borderColor} !important`
      }
      if (this.textColor) {
        styles['color'] = `${this.textColor} !important`
      }
      return styles
    },
		darkenOnHover () {
			return this.backgroundColor === BLUE_COLOUR && this.textColor === WHITE_COLOUR
		},
		hrefIsRelativePath () {
			return this.href && this.href.startsWith('/')
		}
  },
  methods: {
    getVariantFromProps () {
      let variant = 'primary'
      if (this.white) {
        variant = 'secondary'
      } else if (this.red) {
        variant = 'danger'
      } else if (this.gray) {
        variant = 'info'
      } else if (this.transparent) {
        variant = 'light'
      } else if (this.green) {
        variant = 'success'
      }
      return variant
    },
    click (e) {
      if (this.hrefIsRelativePath) {
        this.$router.push(this.href)
			} else if (this.href) {
				window.location.href = this.href
      } else {
        this.$emit('click', e)
      }
    },
		getTextColorFromButton () {
			// Get the color CSS property value from the button
			const button = document.getElementById(this.id)
			return button ? window.getComputedStyle(button).color : ''
		},
		updateInternalTextColor () {
			// Do it in next tick
			this.$nextTick(() => {
				this.lastInternalTextColor = this.internalTextColor
				this.internalTextColor = this.getTextColorFromButton()
			})
		}
  },
	watch: {
		getVariant (newValue) {
			this.updateInternalTextColor()
		},
		textColor (newValue, oldValue) {
			this.lastInternalTextColor = oldValue
			this.internalTextColor = newValue
		},
		getOverridenStyles (newValue) {
			this.updateInternalTextColor()
		}
	},
	mounted () {
		if (this.icon) {
			this.internalTextColor = this.getTextColorFromButton()
		}
	}
}
</script>

<style lang="scss" scoped>
.fit-content {
  min-width: fit-content;
}
/deep/.btn-outline-info {
  color: $gray;
  background-color: transparent;
  border: 1px solid $gray;

  &:hover {
    background-color: white;
    color: $gray;
    border: 1px solid $gray;
  }
}

.darken-on-hover {
	&:hover {
		background-color: darken($blue, 10%) !important;
	}
}

.btn-negative {
	color: white;
	border: 1px solid white;
	background-color: transparent;
}

/deep/ {
	&:focus {
		box-shadow: none;
	}
}

/deep/.no-hover:hover {
	background-color: inherit;
  border-color: inherit;
  color: inherit;
}

</style>


// WEBPACK FOOTER //
// src/components/base/buttons/BaseButton.vue